/**
 * Alterna uma empresa no filtro do Relatório de Vendas. Seleção vazia = todas;
 * marcar todas as empresas uma a uma também volta para "todas" (vazio), para o
 * filtro não ficar preso a uma lista fixa quando uma empresa nova surgir.
 */
export const toggleCompanyId = (selected: number[], companyId: number, allIds: number[]): number[] => {
  const next = selected.includes(companyId)
    ? selected.filter(id => id !== companyId)
    : [...selected, companyId];
  if (allIds.length > 0 && allIds.every(id => next.includes(id))) return [];
  return next;
};
